import React, { useState} from "react";
import {FormFeedback, FormGroup, Input} from 'reactstrap';
import useGlobal from "../utils/globalStore";
import {ValidateStore} from "../api/stores-api";

function CovidStep1(props) {
    // eslint-disable-next-line
    const [globalState, globalActions] = useGlobal();
    const answers = globalState.answers;

    const initialState = {
        "store": {"valid": true },
        "associateName": {"valid": true}}
    const [localState, updateLocalState] = useState(initialState);

    const references = props.references;
    if(references) {
        references[1] =  updateLocalState;
    }

    const handleOnChangeForStore = (e) =>{
        const { value} = e.target;
        //const found = constants.stores.find(element => element === value );
        let storeValidation;

        ValidateStore(value)().then(found => {
            if(found){
                storeValidation = {valid: true}
            }
            else {
                storeValidation = {valid: false}
            }
            updateLocalState(prevState => {
                const newState = {...prevState, "store": storeValidation}
                return newState
            });
        })
        props.handleChange(e);
    }

    return (
        <div>
            <h4>Store Information</h4>
            <hr className="my-2" />
            <FormGroup>
                <Input invalid={answers.store && localState.store.valid ? false : true} type="number" name="store"
                       defaultValue={answers.store}
                       id="store"
                       placeholder="1. Enter Store Number"
                       onChange={handleOnChangeForStore}/>
                <FormFeedback>Enter valid store number</FormFeedback>

            </FormGroup>
            <FormGroup>
                <Input invalid={answers.associateName && localState.associateName.valid ? false: true}
                       type="text" name="associateName"
                       defaultValue={answers.associateName}
                       id="associateName"
                       placeholder="2. Enter Name"
                       onChange={props.handleChange} />
                <FormFeedback>{answers.associateName ? "Invalid Name": "Name is required"}</FormFeedback>
            </FormGroup>
        </div>
    );
}

export default CovidStep1;